import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAssetId, useViewStateSelectors } from 'owa-timestream-asset-sdk';
import { useBooleanState } from 'owa-react-hooks/lib/useBooleanState';
import { useMouseOrPrimaryPointerEvent } from 'owa-react-hooks/lib/useMouseOrPrimaryPointerEvent';

export default observer(function BucketDropTarget({
    inactiveClassName,
    activeClassName,
    hoverClassName,
    minOrder,
    maxOrder,
    children,
}: {
    inactiveClassName?: string;
    activeClassName: string;
    hoverClassName: string;
    minOrder: number;
    maxOrder: number;
    children?: JSX.Element[];
}) {
    const bucketId = useAssetId();

    const { isMovingAssets, getSelectedAssetTypes } = useViewStateSelectors();
    const isActive = isMovingAssets() && !getSelectedAssetTypes().has('bucket');

    const [hover, setHover, resetHover] = useBooleanState(false); // because CSS :hover does not work for touch/pen
    const [onMouseOver, onPointerOver] = useMouseOrPrimaryPointerEvent(setHover);
    const [onMouseOut, onPointerOut] = useMouseOrPrimaryPointerEvent(resetHover);

    const className = isActive ? (hover ? hoverClassName : activeClassName) : inactiveClassName;

    return className ? (
        <div
            className={className}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            onMouseUp={onMouseOut}
            onPointerOver={onPointerOver}
            onPointerOut={onPointerOut}
            onPointerUp={onPointerOut}
            data-bucket-id={bucketId}
            data-target-min-order={minOrder}
            data-target-max-order={maxOrder}>
            {children}
        </div>
    ) : null;
});
